import ChamberCreator from "./chamberCreator";
import FilterCreator from "./filterCreator";
import DelayChannelCreator from "./delayChannelCreator";
import TeslaValveCreator from "./teslaValveCreator";
import DropletCreator from "./dropletCreator";
import TransitionWidthCreator from "./transitionWidthCreator";
import TransitionHeightCreator from "./transitionHeightCreator";

import { loadUserModuleTemplates } from "@/library/userModuleRegistry";
import { createUserTemplateCreator } from "./userTemplateCreator";
import type { UserPresetTemplate } from "@/types/userPresetTemplate";

const builtInCreators: any[] = [
  new ChamberCreator(),          // idx 0
  new FilterCreator(),           // idx 1
  new DelayChannelCreator(),     // idx 2
  new TeslaValveCreator(),       // idx 3
  new DropletCreator(),          // idx 4
  new TransitionWidthCreator(),  // idx 5
  new TransitionHeightCreator(), // idx 6
];

const userTemplates: UserPresetTemplate[] = loadUserModuleTemplates();

const userTemplateCreators: any[] = userTemplates
  .map((t: UserPresetTemplate) => {
    const baseCreator = builtInCreators[t.baseModuleIdx];
    if (!baseCreator) return null;
    return createUserTemplateCreator(t, baseCreator);
  })
  .filter((c: any) => !!c);

const ModuleFactory: any[] = [
  ...builtInCreators,
  ...userTemplateCreators,
];

export default ModuleFactory;
